<template>
  <div>
    <Breadcrumbs></Breadcrumbs>
    <div class="faqs answer">
      <b-row class="justify-content-md-center boxes faq-search-container">
        <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
          <FaqSearchBox></FaqSearchBox>
        </b-col>
      </b-row>
      <div v-if="selectedFaq" class="answer-faqs">
        <StepTitle>{{ selectedFaq.question }}</StepTitle>
        <div class="faq-outer-container mt-3">
          <div>
            <b-row class="boxes">
              <b-col md="12">
                <div class="faq-container">
                  <b-row>
                    <b-col>
                      <p v-html="selectedFaq.answer" class="answer-text"></p>
                    </b-col>
                  </b-row>
                  <div class="thumb">
                    <span>
                      <b-link class="question-answered q_links" @click="vote(selectedFaq, true)"><font-awesome-icon
                        :icon="['far', 'thumbs-up']"></font-awesome-icon> This answers my question</b-link>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div class="des-yes-no">
              <b-row class="justify-content-md-center mr-0 mb-4 ml-0">
                <div class="buttons-orders">
                  <p> Did this help? </p>
                  <b-row class="desk-yes-no justify-content-md-center">
                    <b-col cols="2">
                      <b-button @click="vote(selectedFaq, false)" variant="success"
                                class=" no-btn btn-width des-no custom-no">
                        <span class="no-svg"><font-awesome-icon :icon="['far', 'thumbs-down']"></font-awesome-icon></span>
                        No
                      </b-button>
                    </b-col>
                    <b-col cols="2">
                      <b-button @click="vote(selectedFaq, true)" variant="success"
                                class="yes-btn btn-width des-yes custom-yes">
                        <span class="yes-svg"><font-awesome-icon :icon="['far', 'thumbs-up']"></font-awesome-icon></span>
                        Yes
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-row>
            </div>
            <!-- YES AND NO BUTTONS FOR MOBILE -->
            <div class="d-block d-lg-none">
              <b-row class="justify-content-md-center mr-0 ml-0">
                <div class="buttons-orders sticky-div">
                  <p> Did this help? </p>
                  <b-row>
                    <b-col cols="5" offset="1" class="mob-yes-no-btn">
                      <b-button @click="vote(selectedFaq, false)" variant="success" class="no-btn btn-width ">
                        <span class="no-svg"><font-awesome-icon :icon="['far', 'thumbs-down']"></font-awesome-icon></span>
                        No
                      </b-button>
                    </b-col>
                    <b-col cols="5" offset="" class="mob-yes-no-btn">
                      <b-button @click="vote(selectedFaq, true)" variant="success" class="yes-btn btn-width">
                        <span class="yes-svg"><font-awesome-icon :icon="['far', 'thumbs-up']"></font-awesome-icon></span>
                        Yes
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-row>
            </div>
            <section class="boxes update-back-btn">
              <b-row class="justify-content-md-center">
                <b-col md="4">
                  <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
                </b-col>
              </b-row>
            </section>
          </div>
        </div>
      </div>
      <div class="answer-footer" v-if="relatedFaqs.length > 0">
        <h3 class="position-relative zIndex">Related Questions...</h3>
        <b-row class="questions justify-content-md-center position-relative zIndex" >
          <template v-for="faq in relatedFaqs">
            <b-col v-if="selectedFaq && faq && faq.id !== selectedFaq.id" :key="'faq-' + faq.id" md='4' class="related-q-p">
              <router-link class="faq-link" :to="{ name: 'faq-details', params: { pk: faq.id, slug: faq.slug }}" custom>
                <b-card :title="faq.question" sub-title="" class="my-faq-card-two rel-faq-card h-100">
                  <b-card-text v-html="getShortAnswer(faq)" class="footer-card-answer">
                  </b-card-text>
                  <font-awesome-icon :icon="['far', 'thumbs-up']" class="faq-qtn-icon" @click="vote(faq, true)"></font-awesome-icon>
                </b-card>
              </router-link>
            </b-col>
          </template>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import Breadcrumbs from '@/components/Breadcrumbs'
import FaqSearchBox from '@/components/FaqSearchBox'
import {stopMouseflowRecording} from '@/utils'
const StepTitle = () => import('./StepTitle')

export default {
  name: 'FaqDetails',
  computed: {
    ...mapState(['selectedFaq', 'relatedFaqs', 'votedFaqs', 'isIE', 'session'])
  },
  components: {
    FaqSearchBox,
    Breadcrumbs,
    StepTitle
  },
  watch: {
    $route: function(to, from) {
      this.init() // fetch new faq on route change
    },
    '$store.state.session': function(to, from) {
      if (to && !from) {
        this.init()
      }
    }
  },
  metaInfo: function() {
    let description = 'Faq Details'
    let keywords = null
    let metaInfo = {
      title: this.selectedFaq ? this.selectedFaq.question : 'Faq Details',
      meta: []
    }
    if (this.selectedFaq) {
      description = this.selectedFaq.meta_description || this.selectedFaq.answer
      keywords = this.selectedFaq.keywords
      const descriptionEl = document.createElement('div')
      descriptionEl.innerHTML = description
      description = descriptionEl.textContent || descriptionEl.innerText
      metaInfo.meta.push({name: 'description', content: description})
      metaInfo.meta.push({name: 'keywords', content: keywords || metaInfo.title})
    }
    return metaInfo
  },
  methods: {
    getShortAnswer: function(faq) {
      if (faq.blurb && faq.blurb.length) {
        return faq.blurb
      }

      let div = document.createElement('div')
      div.innerHTML = faq.answer

      return div.innerText
    },
    vote: function(faq, thumbsUp) {
      const path = thumbsUp ? 'upvote' : 'downvote'

      if (!(faq.id in this.votedFaqs)) {
        // faq not yet voted, so vote for it
        this.$store.commit('busy')
        axios.post('/faq/' + faq.id.toString() + '/' + path + '/', {})
          .then(_resp => {
            this.$store.commit('set_faq_vote', faq)
            this.$store.commit('ready')
          })
          .catch(err => {
            console.log(err)
            this.$store.commit('ready')
          })
      }
    },
    init: function() {
      if (!this.session) {
        this.$router.replace({name: 'session'})
        return
      }
      let slug = ''
      if ('slug' in this.$route.params) {
        slug = this.$route.params.slug
      }
      if (slug && slug.length) {
        this.$store.commit('busy')
        this.$store.dispatch('get_faq', {slug})
          .then(result => {
            this.$store.commit('pop_from_step_stack')
            this.$store.commit('ready')
          })
          .catch(err => {
            if (err.response && err.response.status === 302) {
              this.$router.replace({name: 'faq-details', params: {slug: err.response.data.slug}})
            } else {
              console.log(err)
              this.$router.replace({name: 'session'})
            }
          })
      } else {
        console.log('No slug found in route params')
        this.$router.replace({name: 'session'}) // ignore the jump and stay where we are in the session
      }
    },
    goBack: function() {
      this.$router.go(-1)
    }
  },
  created() {
    this.init()
    stopMouseflowRecording()
  }
}
</script>

<style scoped lang="less">

  .answer-footer {
    margin-top: 20px;
    padding: 20px 10px 10px;
    position: relative;

    &:after {
      top: 0;
      z-index: 0;
      content: '';
      left: -2000px;
      bottom: -60px;
      right: -2000px;
      position: absolute;
      background:  var(--default_background_color);
    }

    > h3 {
      text-align: center;
      font-size: 16pt;
      font-weight: normal;
      margin-bottom: 12px;
    }
  }

  .sticky-div {
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    z-index: 100;
    background-color: white;
    padding: 10px 0;

    p {
      padding: 0 !important;
    }
  }

  .yes-svg {
    top: 0;
    left: 0;
    bottom: 0;
    padding: 5px 6px 0;
    position: absolute;
    background: var(--theme_color);
  }

  .no-svg {
    top: 0;
    bottom: 0;
    left: 0 !important;
    padding: 5px 6px 0;
    border-radius: 0 !important;
    position: absolute !important;
    background: var(--light_text_color);
  }

  .buttons-orders {
    .btn-account {
      width: 30%;
    }
    width: 100%;
    text-align: center;
    margin-top: 26px;
    .back-btn {
      background: var(--content_background_color);
      color: var(--theme_color);
      border: 2px solid var(--theme_color);
    }
  }

  .answer-faqs {
    max-width: 80%;
    margin: auto;
    .welcome {
      .title {
        margin-top: 20pt;
        text-align: left !important;
      }
    }
  }

  @media screen and (min-width: 361px) and (max-width: 380px) {
    .no-svg {
      padding: 5px 6px 0;
    }

    .yes-svg {
      padding: 5px 6px 0;
    }
  }

  @media screen and (min-width: 381px) and (max-width: 414px) {
    .yes-svg {
      padding: 5px 6px 0;
    }

    .no-svg {
      padding: 5px 6px 0;
    }
  }

  @media screen and (min-width: 415px) {
    .no-svg {
      padding: 5px 6px 0;
    }

    .yes-svg {
      padding: 5px 6px 0;
    }
  }
</style>
